// Static asset URLs for the application

export const ASSET_URLS = {
  // Polimorphic logo with text
  logo: 'https://s3-us-east-2.amazonaws.com/polimorphic-sha256/beb91328ac6a6969b52cef52032e9bd164462c4ff295c5d9ca4bf266123eb264.png',
  // Polimorphic icon (P logo)
  icon: 'https://s3-us-east-2.amazonaws.com/polimorphic-sha256/f4ed20c98e5e6d456c677870b6efbd8f185d6a60c5774eb2f875534b9d2da3e2/icon-logo.png',
}
